import React from 'react'
import moment from 'moment'
import { modal } from '../../core/utilities/modal'

import { buildingControllers } from '../../core/controllers/BuildingControllers'
import { activeLevelTempetureReadingsManager } from '../../core/controllers/ActiveLevelTempetureReadingsManager'
import { rentlyIntegrationController } from '../../core/controllers/RentlyIntegrationController'

export default class BuildingSensors extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            systemConnected: false,
            systemCheck: null,
            sensors: null
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => this.systemsCheck(), 5000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.props.hasIntegrations == false && nextProps.hasIntegrations) {
            this.systemsCheck(true);
        }
    }

    componentDidUpdate() {
        buildingControllers.determineAvgTemp();
        if(this.state.sensors) {
            activeLevelTempetureReadingsManager.displayAvgTempPerFloorImmediately();
        }
    }

    systemsCheck(forceLoad = false) {
        var self = this;
        if(this.props.hasIntegrations || forceLoad) {
            buildingControllers.getControllers(this.props.buildingId, function(response) {
                if(response.data.all_systems_check == 'healthy') {
                    self.setState({
                        systemConnected: true,
                        systemCheck: response.data['hardware'][0].last_system_check,
                        sensors: response.data.hardware
                    });
                }
            });
        }
    }

    triggerLock(lock) {
        rentlyIntegrationController.triggerLock(lock, function(response) {
            if(response.data.success) {
                var value = 'Unlocked';
                if(response.command == 'lock') {
                    value = 'Locked';
                }
                modal.showInfo(lock.friendly_name + " was successfully " + value + '!', "success", "top", "center");
            } else {
                modal.showInfo(lock.friendly_name + " failed to " + value + '!', "danger", "top", "center");
            }
        });
    }

    render(){
        var self = this;
        const hasIntegrations = this.props.hasIntegrations;
        const systemStatus = this.state.systemConnected;
        const systemCheck = this.state.systemCheck;
        const sensors = this.state.sensors;

        var connected = 'system-red';
        if (systemStatus) {
            connected = 'system-green';
        }
        if(hasIntegrations) {
            return (
                <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"><i class="pe-7s-plug"></i><small><i class="pe-7s-angle-right"></i></small> Sensor Integrations</h4>
                        <p class="category"><i class={"fa fa-circle " + connected}></i> { systemStatus ? 'System Connected' : 'System Disconnected'} - <small>checks every 5 seconds.</small></p>
                    </div>
                    <div class="content">
                        { sensors != null ? (sensors.map(function(sensor, index) {
                            var sensorStatusColor = 'system-green';
                            var sensorStatus = 'Connected';
                            const connectedSensors = sensor.controller.sensors;
                            const sensorTemp = sensor.controller.unit_temp;
                            const sensorHumidity = sensor.controller.unit_humidity;
                            const sensorName = sensor.name;
                            const sensorLevel = sensor.building_level;
                            if(sensor.controller.status != 'okay') {
                                sensorStatusColor = 'system-red';
                                sensorStatus = 'Not Reporting';
                            }
                            return (
                                <div key={index}>
                                    <hr></hr>
                                    <h5 class="title">
                                        <i class="pe-7s-plugin"></i>
                                        <small><i class="pe-7s-angle-right"></i></small> {sensorName} - Level {sensorLevel}
                                    </h5>
                                    <div class="legend">
                                        <i class={"fa fa-circle text-info " + sensorStatusColor}></i> {sensorStatus}&nbsp;&nbsp;
                                        { sensorTemp != null && (
                                            <span>
                                            <i class={"icon-icons8-thermometer-automation text-info"}></i> {sensorTemp}&#8457; - {sensorHumidity}%
                                            </span>
                                        )}
                                    </div>
                                    <div class="legend">
                                        <i class="icon-icons8-sensor"></i> {connectedSensors.length} connected sensors.
                                    </div>
                                    <div class="sensors-container">
                                    {connectedSensors != null && (connectedSensors.map(function(connectedSensor, index) {
                                        if(connectedSensor.mode === 'temp') {
                                            const sensorTemp = connectedSensor.temp;
                                            buildingControllers.tempTally.push(sensorTemp);
                                            buildingControllers.addTempTallyToFloor(sensorLevel, sensorTemp);
                                            const friendlyName = connectedSensor.friendly_name;
                                            return (
                                                <div class="sensor-info" key={index}>
                                                <h5 class="title">
                                                    <i class="icon-icons8-sensor"></i>
                                                    <small><i class="pe-7s-angle-right"></i></small> {friendlyName}
                                                </h5>
                                                <h5 class="title status">
                                                    <b><i class={"icon-icons8-thermometer-automation text-info"}></i> {sensorTemp}&#8457;</b>
                                                </h5>
                                                </div>
                                            )
                                        } else if (connectedSensor.mode === 'door') {
                                            var doorIcon = 'icon-icons8-door-sensor-filled'
                                            var doorAlarmClass = ''
                                            const friendlyName = connectedSensor.friendly_name;
                                            const doorStatus = connectedSensor.friendly_value;
                                            if(doorStatus == 'open') {
                                                doorIcon = 'icon-icons8-door-sensor-alarmed'
                                                doorAlarmClass = 'active-alarm';
                                            }
                                            return (
                                                <div class={"sensor-info " + doorAlarmClass} key={index}>
                                                <h5 class="title">
                                                    <i class="icon-icons8-sensor"></i>
                                                    <small><i class="pe-7s-angle-right"></i></small> {friendlyName}
                                                </h5>
                                                <h5 class="title status">
                                                    <b><i class={"text-info " + doorIcon}></i> {doorStatus}</b>
                                                </h5>
                                                </div>
                                            )
                                        } else if (connectedSensor.mode === 'smoke') {
                                            var smokeIcon = 'icon-icons8-fire-alarm-box'
                                            var alarmClass = ''
                                            const friendlyName = connectedSensor.friendly_name;
                                            const smokeStatus = connectedSensor.friendly_value;
                                            if(smokeStatus == 'alarm') {
                                                alarmClass = 'active-alarm';
                                            }
                                            return (
                                                <div class={"sensor-info " + alarmClass} key={index}>
                                                <h5 class="title">
                                                    <i class="icon-icons8-sensor"></i>
                                                    <small><i class="pe-7s-angle-right"></i></small> {friendlyName}
                                                </h5>
                                                <h5 class="title status">
                                                    <b><i class={"text-info " + smokeIcon}></i> {smokeStatus}</b>
                                                </h5>
                                                </div>
                                            )
                                        } else if (connectedSensor.mode === 'flood') {
                                            var floodIcon = 'icon-icons8-water'
                                            var alarmClass = ''
                                            const friendlyName = connectedSensor.friendly_name;
                                            const floodStatus = connectedSensor.friendly_value;
                                            if(floodStatus == 'wet') {
                                                alarmClass = 'active-alarm';
                                            }
                                            return (
                                                <div class={"sensor-info " + alarmClass} key={index}>
                                                <h5 class="title">
                                                    <i class="icon-icons8-sensor"></i>
                                                    <small><i class="pe-7s-angle-right"></i></small> {friendlyName}
                                                </h5>
                                                <h5 class="title status">
                                                    <b><i class={"text-info " + floodIcon}></i> {floodStatus}</b>
                                                </h5>
                                                </div>
                                            )
                                        } else if (connectedSensor.mode === 'lock') {
                                            var icon = 'pe-7s-door-lock'
                                            var alarmClass = ''
                                            const friendlyName = connectedSensor.friendly_name;
                                            const status = connectedSensor.friendly_value;
                                            if(status == 'unlocked') {
                                                alarmClass = 'active-alarm';
                                            }
                                            return (
                                                <div class={"sensor-info " + alarmClass} key={index}>
                                                <h5 class="title">
                                                    <i class="icon-icons8-sensor"></i>
                                                    <small><i class="pe-7s-angle-right"></i></small> {friendlyName}
                                                </h5>
                                                <h5 class="title status">
                                                    <b><i class={"text-info " + icon}></i> {status}</b>
                                                </h5>
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <button type="button" id="authenticate" data-loading-text="Loading..." class="btn btn-primary btn-warning btn-fill pull-left" autoComplete="off" onClick={self.triggerLock.bind(self, connectedSensor)}>
                                                        { status == 'unlocked' ? (
                                                            <span>Lock Door</span>
                                                        ) : (
                                                            <span>Unlock Door</span>
                                                        )}
                                                        </button>
                                                    </div>
                                                </div>
                                                </div>
                                            )
                                        } else if (connectedSensor.mode === 'contact_sensor') {
                                            var icon = 'pe-7s-attention'
                                            var alarmClass = ''
                                            const friendlyName = connectedSensor.friendly_name;
                                            const status = connectedSensor.friendly_value;
                                            if(status == 'opened') {
                                                alarmClass = 'active-alarm';
                                            }
                                            return (
                                                <div class={"sensor-info " + alarmClass} key={index}>
                                                <h5 class="title">
                                                    <i class="icon-icons8-sensor"></i>
                                                    <small><i class="pe-7s-angle-right"></i></small> {friendlyName}
                                                </h5>
                                                <h5 class="title status">
                                                    <b><i class={"text-info " + icon}></i> {status}</b>
                                                </h5>
                                                </div>
                                            )
                                        }
                                    }))}
                                    </div>
                                </div>
                            )
                        })) : (
                            <p>Could not list any integrations.</p>
                        )}
                    </div>
                </div>
                </div>
            )
        } else {
            return (
                <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"><i class="pe-7s-plugin"></i><small><i class="pe-7s-angle-right"></i></small> Sensor Integrations</h4>
                        <p class="category"><i class="fa fa-circle "></i> No integrations found.</p>
                    </div>
                    <div class="content">
                    </div>
                </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/Building/BuildingSensors.jsx